import { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw, AlertTriangle } from "lucide-react";
import { subscribe, syncNow } from "@/lib/offline";
import { DEVICE_ID } from "@/lib/device";

export function StatusBadge({ compact = false }) {
  const [s, setS] = useState({ online: navigator.onLine, syncing: false, pending: 0, lastError: null });
  useEffect(() => subscribe(setS), []);

  let cfg;
  if (s.lastError) cfg = { text: "SYNC ERROR (Action Required)", Icon: AlertTriangle, cls: "bg-rose-500/25 text-rose-300 border-rose-500/50" };
  else if (s.syncing) cfg = { text: `SYNCING (${s.pending} Pending)`, Icon: RefreshCw, cls: "bg-sky-500/20 text-sky-300 border-sky-500/40", spin: true };
  else if (!s.online) cfg = { text: `OFFLINE (Local Mode)${s.pending ? ` · ${s.pending} queued` : ""}`, Icon: WifiOff, cls: "bg-amber-500/20 text-amber-300 border-amber-500/40" };
  else cfg = { text: s.pending ? `ONLINE · ${s.pending} to sync` : "ONLINE", Icon: Wifi, cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" };

  const { Icon } = cfg;
  return (
    <button
      data-testid="status-indicator"
      onClick={() => syncNow(DEVICE_ID)}
      title={`Click to sync now · last successful sync: ${s.lastSync ? new Date(s.lastSync).toLocaleString() : "never"}`}
      className={`inline-flex items-center gap-2 rounded-md border px-2.5 py-1 text-xs font-semibold ${cfg.cls} touch-btn`}
    >
      <Icon size={14} className={cfg.spin ? "animate-spin-slow" : ""} />
      {!compact && <span data-testid="status-indicator-text">{cfg.text}</span>}
    </button>
  );
}
